export const DEFAULT_HEIGHT = 700
export const DESTINATION_ELEMENT_NAME = 'termly-embed'
